import {TransientJobStatus, TransientJob, TransientSeriesResponse} from '@crema/services/apis/ctdTransient';

// ---------------------------------------------------------------------------
// Action type string constants
// ---------------------------------------------------------------------------

export const CTD_TRANSIENT_UPLOAD_START = 'CTD_TRANSIENT_UPLOAD_START';
export const CTD_TRANSIENT_UPLOAD_SUCCESS = 'CTD_TRANSIENT_UPLOAD_SUCCESS';
export const CTD_TRANSIENT_UPLOAD_FAILURE = 'CTD_TRANSIENT_UPLOAD_FAILURE';

export const CTD_TRANSIENT_POLL_UPDATE = 'CTD_TRANSIENT_POLL_UPDATE';
export const CTD_TRANSIENT_POLL_STOP = 'CTD_TRANSIENT_POLL_STOP';

export const CTD_TRANSIENT_FETCH_HISTORY_START = 'CTD_TRANSIENT_FETCH_HISTORY_START';
export const CTD_TRANSIENT_FETCH_HISTORY_SUCCESS = 'CTD_TRANSIENT_FETCH_HISTORY_SUCCESS';
export const CTD_TRANSIENT_FETCH_HISTORY_FAILURE = 'CTD_TRANSIENT_FETCH_HISTORY_FAILURE';

export const CTD_TRANSIENT_CLEAR_CURRENT_JOB = 'CTD_TRANSIENT_CLEAR_CURRENT_JOB';

export const CTD_TRANSIENT_SERIES_FETCH_START = 'CTD_TRANSIENT_SERIES_FETCH_START';
export const CTD_TRANSIENT_SERIES_FETCH_SUCCESS = 'CTD_TRANSIENT_SERIES_FETCH_SUCCESS';
export const CTD_TRANSIENT_SERIES_FETCH_FAILURE = 'CTD_TRANSIENT_SERIES_FETCH_FAILURE';

// ---------------------------------------------------------------------------
// Action interfaces
// ---------------------------------------------------------------------------

/** Fired when the upload request is sent (sets isUploading = true). */
export interface CTDTransientUploadStartAction {
  type: typeof CTD_TRANSIENT_UPLOAD_START;
}

/** Fired when the backend returns the new job_id (upload succeeded). */
export interface CTDTransientUploadSuccessAction {
  type: typeof CTD_TRANSIENT_UPLOAD_SUCCESS;
  payload: {
    jobId: number;
    status: string;
  };
}

/** Fired when the upload request fails. */
export interface CTDTransientUploadFailureAction {
  type: typeof CTD_TRANSIENT_UPLOAD_FAILURE;
  error: string;
}

/** Fired on each polling tick with the latest job state from the API. */
export interface CTDTransientPollUpdateAction {
  type: typeof CTD_TRANSIENT_POLL_UPDATE;
  payload: TransientJobStatus;
}

/** Fired to signal that active polling should cease. */
export interface CTDTransientPollStopAction {
  type: typeof CTD_TRANSIENT_POLL_STOP;
}

/** Fired when the history-fetch request is sent. */
export interface CTDTransientFetchHistoryStartAction {
  type: typeof CTD_TRANSIENT_FETCH_HISTORY_START;
}

/** Fired when the history list is successfully retrieved. */
export interface CTDTransientFetchHistorySuccessAction {
  type: typeof CTD_TRANSIENT_FETCH_HISTORY_SUCCESS;
  payload: TransientJob[];
}

/** Fired when the history-fetch request fails. */
export interface CTDTransientFetchHistoryFailureAction {
  type: typeof CTD_TRANSIENT_FETCH_HISTORY_FAILURE;
  error: string;
}

/** Fired to reset the current job so the user can start a new submission. */
export interface CTDTransientClearCurrentJobAction {
  type: typeof CTD_TRANSIENT_CLEAR_CURRENT_JOB;
}

/** Fired when a node-series request is sent. */
export interface CTDTransientSeriesFetchStartAction {
  type: typeof CTD_TRANSIENT_SERIES_FETCH_START;
}

/** Fired when the requested node series is retrieved. */
export interface CTDTransientSeriesFetchSuccessAction {
  type: typeof CTD_TRANSIENT_SERIES_FETCH_SUCCESS;
  payload: TransientSeriesResponse;
}

/** Fired when the node-series request fails. */
export interface CTDTransientSeriesFetchFailureAction {
  type: typeof CTD_TRANSIENT_SERIES_FETCH_FAILURE;
  error: string;
}

// ---------------------------------------------------------------------------
// Union type consumed by the reducer
// ---------------------------------------------------------------------------

export type CTDTransientActions =
  | CTDTransientUploadStartAction
  | CTDTransientUploadSuccessAction
  | CTDTransientUploadFailureAction
  | CTDTransientPollUpdateAction
  | CTDTransientPollStopAction
  | CTDTransientFetchHistoryStartAction
  | CTDTransientFetchHistorySuccessAction
  | CTDTransientFetchHistoryFailureAction
  | CTDTransientClearCurrentJobAction
  | CTDTransientSeriesFetchStartAction
  | CTDTransientSeriesFetchSuccessAction
  | CTDTransientSeriesFetchFailureAction;
